export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usuario no encontrado"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleccionar"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cerrar"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buscar"])}
}